module.exports = __webpack_public_path__ + "static/media/moon.2d4653c0.svg";